<template>
  <div class="index-container">
    <div class="tabs-box">
      <tab-list :tabsData="tabsData" @clickInfo="clickInfo"> </tab-list>
    </div>
    <div class="body-content">
      <invite-tenders-list
        v-for="(item, index) in list"
        :key="index"
        :item="item"
      ></invite-tenders-list>
    </div>
  </div>
</template>

<script>
import tabList from '../../components/tabs-list-cp';
import inviteTendersList from './components/invite-tenders-list';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'index',

  data() {
    return {
      tabsData: [
        {
          name: '所有招标',
          active: 0
        },
        {
          name: '未接受',
          active: 1
        },
        {
          name: '进行中',
          active: 2
        },
        {
          name: '已结束',
          active: 3
        }
      ],
      list: [],
      current: 1,
      size: 10,
      providerGuid: ''
    };
  },
  mounted() {},
  created() {
    let { providerGuid } = getUrlParams();
    this.providerGuid = providerGuid;
    this._getBiddingProgress({ type: 'all' });
  },
  components: {
    tabList,
    inviteTendersList
  },

  methods: {
    _getBiddingProgress(params) {
      let { current, providerGuid, size } = this;
      params = { current, size, providerGuid, ...params };
      this.$api.getBiddingProgress(params).then(res => {
        let { code, body } = res;
        if (code == '0000') {
          let { records } = body;
          this.list = records;
        }
      });
    },
    clickInfo(data) {
      let json = {
        0: 'all',
        1: 'unReceive',
        2: 'doing',
        3: 'finished'
      };
      this._getBiddingProgress({ type: json[data] });
    }
  }
};
</script>

<style scoped lang="scss">
.index-container {
  font-family: PingFang SC;
  background: #f2f2f2;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; //有回弹效果;
  .tabs-box {
    position: fixed;
    width: 100%;
    top: 0;
    height: auto;
    z-index: 999;
  }
  .body-content {
    margin-top: 88px;
  }
}
</style>
<style lang="scss">
.index-container {
}
</style>
